import { render } from "./QuizStepsPage.vue?vue&type=template&id=296b9f7d&scoped=true"
import script from "./QuizStepsPage.vue?vue&type=script&lang=js"
export * from "./QuizStepsPage.vue?vue&type=script&lang=js"

import "./QuizStepsPage.vue?vue&type=style&index=0&id=296b9f7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296b9f7d"]])

export default __exports__